"use client";

import * as React from "react";
import { Scale, TrendingDown, ShieldCheck, Landmark, ArrowRight, Percent } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { Progress } from "@/components/ui/progress";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const taxComparisonData = [{
  id: "rental",
  type: "Transaktionskosten",
  nl: "Hoch (Banken)",
  dxb: "Minimal"
}, {
  id: "capital",
  type: "Geschwindigkeit",
  nl: "Tage (SWIFT)",
  dxb: "Sekunden"
}, {
  id: "corporate",
  type: "Transparenz",
  nl: "Begrenzt",
  dxb: "Blockchain"
}];
export default function DutchTaxAdvantage() {
  return <section data-section-id="247122" id="cryptophilanthropybenefits" className="bg-background text-white">
      {}
      <div className="bg-background text-foreground py-20 lg:py-32">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
          
          {}
          <div className="max-w-4xl mx-auto mb-16">
            <Card className="bg-primary border-primary shadow-lg shadow-primary/5 text-white rounded-xl">
              <CardHeader className="text-center pb-2">
                <CardTitle className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-4">
                  Vorteile der Crypto-Philanthropie
                </CardTitle>
                <CardDescription className="text-white/90 text-lg md:text-xl font-default font-normal leading-relaxed max-w-3xl mx-auto">
                  Entdecken Sie, wie digitale Währungen die Effizienz Ihrer gemeinnützigen Beiträge steigern und maximale Transparenz für Stiftungen und Donoren schaffen.
                </CardDescription>
              </CardHeader>
              <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
                <div className="space-y-2">
                  <h3 className="font-bold text-xl">Schweizer Präzision</h3>
                  <p className="text-white/80 leading-relaxed">Höchste Standards in der Abwicklung und Verwaltung Ihrer digitalen Assets nach bewährten Schweizer Finanzprinzipien.</p>
                </div>
                <div className="space-y-2">
                  <h3 className="font-bold text-xl">Maximale Transparenz</h3>
                  <p className="text-white/80 leading-relaxed">Jede Spende ist auf der Blockchain nachverfolgbar, was volles Vertrauen zwischen Donor und Hilfsprojekt schafft.</p>
                </div>
                <div className="space-y-2">
                  <h3 className="font-bold text-xl">Effiziente Abwicklung</h3>
                  <p className="text-white/80 leading-relaxed">Reduzierung administrativer Hürden und Kosten durch automatisierte Prozesse und Smart Contracts.</p>
                </div>
                <div className="space-y-2">
                  <h3 className="font-bold text-xl">Persönliche Beratung</h3>
                  <p className="text-white/80 leading-relaxed">Individuelle Unterstützung für Stiftungen bei der Integration von Krypto-Spenden in ihre bestehende Struktur.</p>
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            
            {}
            <div className="bg-primary border border-primary shadow-lg shadow-primary/5 flex flex-col rounded-lg p-6 gap-6">
              <CardHeader className="px-0 py-0">
                <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                  <Scale className="h-6 w-6 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-default text-2xl text-white">Effizienz & Speed</CardTitle>
                <CardDescription className="font-default text-base mt-2 text-white/90">
                  Globale Reichweite ohne Grenzen
                </CardDescription>
              </CardHeader>
              <CardContent className="flex-grow px-0">
                <p className="text-white font-default leading-relaxed">
                  Crypto-Spenden umgehen langsame Bankenkorrespondenzen. Gelder erreichen Hilfsprojekte weltweit in Echtzeit, was besonders in Krisensituationen lebensrettend sein kann.
                </p>
              </CardContent>
              <CardFooter className="px-0 py-0">
                <Button variant="link" className="text-white p-0 h-auto font-default group" asChild>
                  <Link to="/DonorsPage">
                    Mehr für Donoren <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </CardFooter>
            </div>

            {}
            <div className="bg-primary border border-primary shadow-lg shadow-primary/5 flex flex-col rounded-lg p-6 gap-6">
              <CardHeader className="px-0 py-0">
                <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                  <TrendingDown className="h-6 w-6 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-default text-2xl text-white">Kostenvergleich</CardTitle>
                <CardDescription className="font-default text-base mt-2 text-white/90">
                  Traditionell vs. Crypto4Good
                </CardDescription>
              </CardHeader>
              <CardContent className="flex-grow pt-0 px-0">
                <Table>
                  <TableHeader>
                    <TableRow className="border-primary/10 hover:bg-transparent">
                      <TableHead className="text-white font-default">Merkmal</TableHead>
                      <TableHead className="text-white font-default">Bank</TableHead>
                      <TableHead className="text-white font-default text-right">Crypto</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {taxComparisonData.map((row, i) => <TableRow key={row.id} data-index={i} className="border-primary/10 hover:bg-primary/5">
                        <TableCell className="font-medium text-white font-default">{row.type}</TableCell>
                        <TableCell className="text-white font-default">{row.nl}</TableCell>
                        <TableCell className="text-white font-semibold font-default text-right">{row.dxb}</TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
                <p className="text-xs text-white mt-4 font-default italic">
                  *Basierend auf durchschnittlichen Gebühren für internationale Überweisungen im Vergleich zu Layer-2 Blockchain-Lösungen.
                </p>
              </CardContent>
            </div>

            {}
            <div className="bg-primary border border-primary shadow-lg shadow-primary/5 flex flex-col rounded-lg p-6 gap-6">
              <CardHeader className="px-0 py-0">
                <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                  <Percent className="h-6 w-6 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-default text-2xl text-white">Impact-Maximierung</CardTitle>
                <CardDescription className="font-default text-base mt-2 text-white/90">
                  Netto-Spendenwert Optimierung
                </CardDescription>
              </CardHeader>
              <CardContent className="flex-grow space-y-8 px-0">
                <div className="space-y-3">
                  <div className="flex justify-between items-end">
                    <span className="text-sm font-medium text-white font-default">Crypto4Good Impact</span>
                    <span className="text-xl font-default text-white">~99%</span>
                  </div>
                  <Progress value={99} className="h-1.5 bg-muted" />
                  <p className="text-xs text-white font-default">Fast jeder Rappen fliesst direkt ins Projekt.</p>
                </div>
                
                <Separator className="bg-primary/10" />
                
                <div className="space-y-3">
                  <div className="flex justify-between items-end">
                    <span className="text-sm font-medium text-white font-default">Traditionell (Est.)</span>
                    <span className="text-xl font-default text-white">~85%</span>
                  </div>
                  <Progress value={85} className="h-1.5 bg-muted [&>div]:bg-white/40" />
                  <p className="text-xs text-white font-default">Nach Abzug von Bank- und Wechselgebühren.</p>
                </div>
              </CardContent>
            </div>

          </div>

          {}
          <Alert className="rounded-lg border-l-4 border-l-primary border-y-0 border-r-0 bg-secondary text-foreground shadow-md py-6 px-6 md:px-8 flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="flex-shrink-0 bg-primary/10 p-3 rounded-lg">
              <ShieldCheck className="h-8 w-8 text-primary" strokeWidth={1.5} />
            </div>
            <div className="flex-grow">
              <AlertTitle className="font-default text-xl md:text-2xl text-foreground mb-2">
                Sicherheit & Compliance
              </AlertTitle>
              <AlertDescription className="font-default text-foreground text-base leading-relaxed max-w-4xl">
                <p>Crypto4Good ist eine non-custodial Plattform und hält keinerlei Kundengelder oder Private Keys. Wir betreiben kein KYC. Jede Spende wird dezentral und direkt zwischen Spender und Stiftung abgewickelt – unter Einhaltung höchster technischer Sicherheitsstandards (z. B. durch Smart Contracts und direkte On-Chain-Transaktionen).</p>
                <p className="mt-2">Zum Schutz vor Missbrauch und zur Einhaltung der Sorgfaltspflichten nach Schweizer GWG ist eine Spenden‑Höchstgrenze von umgerechnet CHF 5'000 pro Transaktion bzw. Spender und Kalenderjahr festgelegt (dies kann bei Bedarf angepasst werden).</p>
                <p className="mt-2">Crypto4Good operiert nach strengsten Schweizer Standards im Non‑Custodial‑Bereich. Vertrauen durch Transparenz und dezentrale Technologie ist die Basis unserer Plattform.</p>
              </AlertDescription>
            </div>
            <div className="flex-shrink-0 mt-4 md:mt-0">
              <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-md font-default uppercase tracking-wider text-xs px-6 py-5" asChild>
                <Link to="/FoundationsPage">
                  Für Stiftungen
                </Link>
              </Button>
            </div>
          </Alert>

        </div>
      </div>
    </section>;
}